import { gql } from '@apollo/client'

export const GET_LOCATION_PRESETS = gql`
    query GetLocationPresets($campaignId: ID) {
        LocationPreset {
            locationPresets(campaignId: $campaignId) {
                id
                name
                included_countries
                excluded_countries
                campaign_id
                created_at
                updated_at
            }
        }
    }
`

export const CREATE_LOCATION_PRESET = gql`
    mutation CreateLocationPreset($input: LocationPresetInput!) {
        createLocationPreset(input: $input) {
            id
            name
            included_countries
            excluded_countries
            campaign_id
            created_at
            updated_at
        }
    }
`

export const UPDATE_LOCATION_PRESET = gql`
    mutation UpdateLocationPreset($id: ID!, $input: LocationPresetUpdateInput!) {
        updateLocationPreset(id: $id, input: $input) {
            id
            name
            included_countries
            excluded_countries
            created_at
            updated_at
        }
    }
`

export const DELETE_LOCATION_PRESET = gql`
    mutation DeleteLocationPreset($id: ID!) {
        deleteLocationPreset(id: $id)
    }
`